export function formatDate(
  dateStr: string,
  includeTime = false,
  timeZone?: string,
) {
  return new Date(dateStr).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
    ...(timeZone && { timeZone }),
    ...(includeTime && {
      hour: "numeric",
      minute: "2-digit",
      ...(timeZone && { timeZoneName: "short" }),
    }),
  })
}
